export const VALID_EMAIL_REGEX = /^(.*@.*\..*|^$)$/;
export const VALID_PHONE_REGEX = /^(\+[0-9()\-\s]+|^$)$/;
